export const WorkerEmbeddedPages = {
  DashboardWorker: "dashboard-worker",
  ProfileWorker: "profile-worker",
} as const;
